import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import AppContainer from "../../Components/Structure/AppContainer";
import AccountActivations from "../../Components/Transactions/AccountActivations";
import CallTransactions from "../../Components/Transactions/CallTransactions";
import MessageTransactions from "../../Components/Transactions/MessageTransactions";
import DirectMessageTransactions from "../../Components/Transactions/DirectMessageTransactions";
import PocketMoneyConversions from "../../Components/Transactions/PocketMoneyConversions";

function BuzztimeChargesPage() {
 
  return (
    <AppContainer title="Transaction Categories">

        <div className="row">
                    <div className="col-lg-12 col-md-12 mt-3">
                <div className="card height-auto">
                    <div className="card-body">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Row>
                                <Col sm={12}>
                                    <Nav variant="pills" className="flex-row mb-1">
                                        <Nav.Item>
                                            <Nav.Link size="sm" eventKey="first">
                                            Account Activations{" "}
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link size="sm" eventKey="second">
                                            Pocket Money Conversion{" "}
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link size="sm" eventKey="third">
                                            Call Charges{" "}
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link size="sm" eventKey="fourth">
                                            Chat Charges{" "}
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link size="sm" eventKey="fifth">
                                            Direct Message Charges{" "}
                                            </Nav.Link>
                                        </Nav.Item>
                                        
                                       
                                    </Nav>
                                </Col>

                                <Col sm={12}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <AccountActivations/>
                                            
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <PocketMoneyConversions/>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third">
                                            <CallTransactions/>
                                             
                                        </Tab.Pane>
                                         <Tab.Pane eventKey="fourth">
                                             <MessageTransactions/>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="fifth">
                                            <DirectMessageTransactions/> 
                                        </Tab.Pane>
                                        
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>  
      
                    </div>
                </div>
                    </div> 
        </div>
     
    </AppContainer>
  );
}

export default BuzztimeChargesPage;